import { Box, Grid, Slider, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { format, parseISO } from 'date-fns';
import React from 'react';

//Made with the help of this tutorial https://programmingwithmosh.com/react/build-a-react-calendar-component-from-scratch/
const getTimeValue = value => {
    if (value < 12) {
        return value + 'am';
    } else if (value === 12) {
        return value + 'pm';
    } else if (value > 12) {
        let pmVal = value - 12;
        return pmVal + 'pm';
    } else {
        return value;
    }
};

const EditAppointment = props => {
    return (
        <Box
            sx={{
                height: '100%',
                backgroundColor: 'white',
                padding: '16px',
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h3" component="h3">
                        {props.title}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {props.editAppt.startDate !== '' ? (
                        <Typography variant="h4" component="h4">
                            Date:{' '}
                            {format(
                                parseISO(props.editAppt.startDate),
                                'dd MMM yyyy'
                            )}
                        </Typography>
                    ) : (
                        <div></div>
                    )}
                </Grid>
                <Grid item xs={12} style={{ padding: '10px 30px' }}>
                    <Slider
                        value={props.editAppt.time}
                        onChange={props.handleEditSliderChange()}
                        valueLabelFormat={getTimeValue}
                        valueLabelDisplay="auto"
                        step={1}
                        min={6}
                        max={22}
                        aria-labelledby="range-slider"
                        getAriaValueText={getTimeValue}
                        marks={props.marks}
                    />
                </Grid>
                <Grid item xs={8} sm={4}>
                    <Typography variant="h6">Available From:</Typography>
                    <Typography variant="h6">Available To:</Typography>
                    <Typography variant="h6">Available Hours:</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6">
                        {getTimeValue(props.editAppt.time[0])}
                    </Typography>
                    <Typography variant="h6">
                        {getTimeValue(props.editAppt.time[1])}
                    </Typography>
                    <Typography variant="h6">
                        {props.editAppt.time[1] - props.editAppt.time[0]}
                    </Typography>
                </Grid>
                <Grid
                    container
                    directon="row"
                    spacing={3}
                    justifyContent="left"
                    sx={{ padding: '20px' }}
                >
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        sx={{
                            width: '100%',
                            textAlign: 'left',
                        }}
                    >
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                props.editCallback(props.editAppt);
                            }}
                            loading={props.load.save}
                        >
                            Save
                        </LoadingButton>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        sx={{
                            width: '100%',
                            textAlign: 'right',
                        }}
                    >
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            data-cy="delete-avail"
                            onClick={() => {
                                props.deleteCallback(props.editAppt);
                            }}
                            loading={props.load.delete}
                        >
                            Delete
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default EditAppointment;
